import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";

export function ProtectedRoute({ superadminOnly = false }: { superadminOnly?: boolean } = {}) {
  const { isAuthenticated, isLoading, user } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg-2">
        <div className="text-ink-3 text-sm">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Save the intended destination so we can redirect after login
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }

  if (superadminOnly && !user?.is_superadmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
